import styled from 'styled-components';

export const Container = styled.div`
   top: 0;
   left: 0;
   position: fixed;
   width: 100%;
   height: 100%;
   z-index: 999999999;
`;
export const Options = styled.ul`
   position: fixed;
   visibility: hidden;
   z-index: 1;
   border-radius: 0.42rem;
   background: #fff;
   box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.2);
   > li {
      list-style: none;
      cursor: pointer;
      padding: 0.925rem 1.5rem;
      position: relative;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.82rem;
      color: black;
      transition: all 260ms ease-in-out;
      &:hover {
         color: black;
         background-color:#f5f6f6; ;
      }
   }
`;